export const FETCH_USER_PROFILE = 'user/FETCH_USER_PROFILE';
export const UPDATE_USER_PROFILE = 'user/UPDATE_USER_PROFILE';
